// A composite cell's body: the table with its per-cell provenance. A click on
// a cell opens the provenance window, as in the chat. Props and callbacks only:
// the dataset and script loaders come from the page.
import React, { useState } from 'react'
import CompositeTable from '../../composite-table/CompositeTable'
import ProvenanceModal, { type DatasetLoader, type TextLoader } from '../../composite-table/ProvenanceModal'
import type { CellProvenance, ProvenanceSidecar, RunReceipt } from '../../composite-table/provenance.generated'

export interface NotebookCompositeCellProps {
  data: Record<string, unknown>
  title?: string
  loadDataset: DatasetLoader
  loadScript: TextLoader
}

export const NotebookCompositeCell: React.FC<NotebookCompositeCellProps> = ({ data, title, loadDataset, loadScript }) => {
  const [open, setOpen] = useState<{ provenance: CellProvenance; run?: RunReceipt } | null>(null)
  const provenance = data.provenance as ProvenanceSidecar | undefined
  return (
    <>
      <CompositeTable
        data={data.platinumData as never}
        provenance={provenance}
        title={title}
        onCellClick={(_row, _col, cellProvenance) => setOpen({ provenance: cellProvenance, run: provenance?.run })}
      />
      <ProvenanceModal
        open={open !== null}
        onClose={() => setOpen(null)}
        provenance={open?.provenance ?? null}
        run={open?.run}
        loadDataset={loadDataset}
        loadScript={loadScript}
      />
    </>
  )
}

export default NotebookCompositeCell
